import React from "react";
import "./Landing.scss";

export default function Shadow() {
  return (
    <div className="shadow-main ">
      <div className="shadow-header flex-top">
        <h1 className="diablos-intro">
          The Cult of Diablos... That's our <span className="enemy-span">enemy</span>.
        </h1>
      </div>
      
    </div>
  );
}
